import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  // { path: 'about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
  Shell.childRoutesForAccount([]),
  Shell.childRoutesForStudent([]),
  Shell.childRoutesForLearningLab([]),
  Shell.childRoutesForLearningLabCertificate([]),
  Shell.childRoutesForInstructor([]),
  Shell.childRoutesForInstructorAssignment([]),
  Shell.childRoutesForInstructorCourse([]),
  Shell.childRoutesForWelcome([]),
  Shell.childRoutesForPublic([]),
  Shell.childRoutesForTermsAndCondition([]),
  // For dev purposes
  // { path: '', loadChildren: () => import('./screens/screens.module').then((m) => m.ScreensModule) },
  // HACK:: workaround for routing language paths, need to check our routing mechanism again,
  // because we don't need this such config in a normal angular app
  { path: 'ar', redirectTo: 'home', pathMatch: 'full' },
  { path: 'ar/:id', redirectTo: ':id' },
  { path: 'en', redirectTo: 'home', pathMatch: 'full' },
  { path: 'en/:id', redirectTo: ':id' },

  { path: '**', redirectTo: '404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
